import React, { useState } from 'react';
import { Column } from '.';

interface ThumbnailCellProps {
  src: string;
  thumbnailConfig?: Column['thumbnail'];
}

export const ThumbnailCell: React.FC<ThumbnailCellProps> = ({
  src,
  thumbnailConfig,
}) => {
  const [isHovering, setIsHovering] = useState(false);

  const width = thumbnailConfig?.width || 50;
  const height = thumbnailConfig?.height || 50;

  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      {/* Thumbnail — overflow hidden clips the metadata bars at top/bottom.
          object-position: center keeps the vehicle in frame. */}
      <div style={{ width, height }} className="overflow-hidden rounded">
        <img
          src={src}
          alt="Thumbnail"
          style={{
            width: '100%',
            // Taller than the container so the top/bottom metadata gets clipped
            height: '160%',
            objectFit: 'cover',
            // Shift up slightly to centre on the vehicle rather than the very middle
            objectPosition: 'center 35%',
            marginTop: '-20%',
          }}
        />
      </div>

      {/* Hover preview — also cropped the same way for consistency */}
      {isHovering && (
        <div
          className="fixed z-50 pointer-events-none overflow-hidden rounded-lg shadow-xl"
          style={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '480px',
            height: '240px',
            maxWidth: '80vw',
          }}
        >
          <img
            src={src}
            alt="Full Image"
            style={{
              width: '100%',
              height: '160%',
              objectFit: 'cover',
              objectPosition: 'center 35%',
              marginTop: '-1S0%',
            }}
          />
        </div>
      )}
    </div>
  );
};
